import { Box, Typography, Avatar, Divider, Stack, IconButton } from "@mui/material";
import { BASE_URL } from "../../api/api";


export default function ShareArticle({ author }) {
  // इमेज URL हैंडलर
  const getAvatarUrl = (path) => {
    if (!path) return '';
    return path.startsWith("http") ? path : `${BASE_URL}${path}`;
  };

  // सोशल लिंक हेल्पर (कोड साफ़ रखने के लिए)
  const getSocialLink = (platform) => author?.[platform] || author?.social_links?.[platform];

  return (
    <Box className="w-full p-4 max-w-2xl mx-auto">
      {/* Author Section */}
      <Stack 
        direction="row" 
        spacing={2} 
        mt={3} 
        justifyContent="space-between" 
        alignItems="center" 
        className="mb-3"
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Avatar 
            src={getAvatarUrl(author?.profile_image)} 
            sx={{ width: 50, height: 50, border: '1px solid #eee' }} 
          />
          <Typography className="font-semibold text-gray-900" sx={{ fontWeight: 600 }}>
            By {author?.name || 'Admin'}
          </Typography>
        </Box>
      </Stack>

      {/* Bio Section */}
      {author?.bio && (
        <Typography 
          className="text-gray-700 text-sm leading-6 mb-2" 
          sx={{ mb: 2, mt: 2, color: 'text.secondary', fontSize: '14px' }}
        >
          {author?.bio}
        </Typography>
      )}
      
      <Divider className="my-4" />
    </Box>
  );
}